/**
 * The VehicleWheel3D placement warning; a detached wheel still parses and renders.
 * Godot has no 2D vehicle wheel, but the factory shape matches the sibling physics
 * rules, and ruleCoverage derives the rule name from it.
 */
import { armEmits, groundedArm, reportArm } from '../ruleArms.js';
import { dimSuffix } from './dim.js';
import { parentTypeVerdict } from '../parentType.js';
export function makeVehicleWheelLinterRule(dim) {
    const type = `VehicleWheel${dim}`;
    const bodyType = `VehicleBody${dim}`;
    const prefix = `vehiclewheel${dimSuffix(dim)}`;
    const arms = {
        notUnderVehicleBody: groundedArm(`${prefix}-not-under-vehicle-body`, { kind: 'configuration-warning' }),
    };
    function check(context) {
        const diagnostics = [];
        const { node, scene } = context;
        // Godot: "Please use it as a child of a VehicleBody3D", and only a direct child
        // is picked up. `cast_to<VehicleBody3D>` (vehicle_body_3d.cpp:147) accepts
        // subclasses, the comparison `parentTypeVerdict` makes.
        const placement = parentTypeVerdict(scene, node, bodyType);
        // An instanced parent's class is in a file this linter never opens, so
        // `unknowable` stays silent, as in nodes/2d/parallaxlayer/linter.ts and
        // physics/joints/shared/linter.ts. `root` still warns.
        if (placement.kind === 'root' || placement.kind === 'mismatch') {
            reportArm(diagnostics, arms.notUnderVehicleBody, node, `${type} '${node.name}' is not a direct child of a ${bodyType}. Godot only attaches wheels that are direct children of the vehicle body; this wheel will do nothing.`);
        }
        // No check between damping_relaxation and damping_compression: both are
        // PROPERTY_HINT_NONE with plain setters, and the "relaxation should be
        // slightly higher" relationship exists only in class-reference prose.
        return diagnostics;
    }
    return {
        meta: {
            name: `valid-${prefix}`,
            description: `Validates ${type} placement under a ${bodyType}`,
            category: 'validation',
            applicableNodeTypes: [type],
            emits: armEmits(arms),
        },
        check,
    };
}
//# sourceMappingURL=vehicleWheelLinterRule.js.map